import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkAnswer } from "../../redux/home/actions";

const useQuestionOfDay = () => {
  const [state, setState] = useState({
    id: "",
    question: "",
    options: [],
    selectedOption: null,
    isCelebrate: false,
  });
  const questionOfDay = useSelector((state) => state.home.questionOfDay.data);
  const user = useSelector((state) => state.auth.user.data);
  const dispatch = useDispatch();

  const handleOptionSelect = (id) => {
    setState((state) => ({ ...state, selectedOption: id }));
  };

  const submitAnswer = () => {
    if (state.selectedOption) {
      let right = questionOfDay?.question?.CorrectAnswer?.[0];
      if (right === state.selectedOption.toString()) {
        setState((state) => ({
          ...state,
          isCelebrate: true,
          correctAns: +right,
        }));
      } else {
        setState((state) => ({
          ...state,
          isCelebrate: false,
          correctAns: +right,
        }));
      }
      const payload = {
        answer: state.selectedOption,
        right,
        quesId: questionOfDay?.question?.objectId,
        qodPtrId: questionOfDay?.id,
        customer: user?.objectId,
      };
      dispatch(checkAnswer(payload));
    }
  };
  useEffect(() => {
    if (questionOfDay?.id) {
      let questionOpt = [];
      for (let i = 1; i <= 5; i++) {
        const opt = questionOfDay?.question?.[`Opt${i}`];
        if (opt) {
          questionOpt.push({ text: opt, id: i });
        }
      }
      setState(() => ({
        id: questionOfDay.id,
        question: questionOfDay?.question?.QuesTitle,
        options: questionOpt,
      }));
    } else {
      setState({ id: "", question: "", options: [] });
    }
  }, [questionOfDay]);
  return {
    state,
    handleOptionSelect,
    submitAnswer,
  };
};

export default useQuestionOfDay;
